import { useState } from "react";
import { createPortal } from "react-dom";
import { Box, Dialog, DialogContent } from "@mui/material";
import { useGridStackContext } from "../../../../contexts/grid-stack-context";
import DeletePartDialog from "../../../ConfigurationModule/components/PartsConfiguration/DeletePartDialog";
import loadingPanelGif from "../../../../assets/animations/loading-panel-kodo.gif";
import "./GridStack.css";

function parseWeightMetaToComponentData(meta) {
  let error = null;
  let name = "";
  let props = {};
  try {
    if (meta.content) {
      const result = JSON.parse(meta.content);
      name = result.name;
      props = result.props;
    }
  } catch (e) {
    error = e;
  }
  return { name, props, error };
}

function PanelPortal({
  id,
  meta,
  WidgetComponent,
  widgetContainer,
  onRemove,
  componentData,
  title,
  description,
  tableId,
  workstream,
}) {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleOpen = () => setConfirmOpen(true);
  const handleClose = () => setConfirmOpen(false);
  const handleConfirmDelete = () => {
    onRemove(id, tableId);
    setConfirmOpen(false);
  };

  // Verificar si el panel está cargando filtros
  const isLoadingFilters = meta.props?.isLoadingFilters || false;

  return createPortal(
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
      key={`grid-stack-container-${id}`}
      id={`grid-stack-container-${id}`}
    >
      {/* Loading overlay para filtros */}
      {isLoadingFilters && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10,
            backdropFilter: "blur(2px)",
          }}
        >
          <img
            src={loadingPanelGif}
            alt="Loading filters"
            style={{
              width: "60px",
              height: "60px",
            }}
          />
          {/* <div
            style={{
              fontWeight: "bold",
              fontSize: "0.9rem",
              color: "#333333",
              marginTop: "10px",
            }}
          >
            Applying filters...
          </div>
          <div style={{ fontSize: "0.7rem", color: "#888" }}>
            Please wait while we update your data
          </div> */}
        </div>
      )}

      {/* <div className="panel-header-title">
        <span>{title}</span>
        <p>{description}</p>
      </div> */}
      {componentData.name !== "ConfigurePanel" &&
        componentData.name !== "KpiChart" && (
          <div className="panel-header-title">
            <span>{title}</span>
            <p>{description}</p>
          </div>
        )}

      <div className="panel-close-button" onClick={handleOpen}>
        <span className="icon-cross" />
      </div>

      {/* Contenedor para la tabla con scroll solo en la tabla */}
      <div
        style={{
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {/* Si el WidgetComponent es una tabla, pásale el height dinámico */}
        {WidgetComponent && WidgetComponent.displayName === "TableComponent" ? (
          <WidgetComponent
            key={`grid-stack-container-${id}-custom-component`}
            {...meta.props}
            panel={meta}
            panelId={id}
            workstream={workstream}
            maxBodyHeight="100%"
          />
        ) : (
          <WidgetComponent
            key={`grid-stack-container-${id}-custom-component`}
            {...meta.props}
            panel={meta}
            panelId={id}
            workstream={workstream}
          />
        )}
      </div>

      <Dialog
        open={confirmOpen}
        onClose={handleClose}
        BackdropProps={{ style: { backdropFilter: "blur(4px)" } }}
      >
        <DialogContent>
          <DeletePartDialog
            message={`Are you sure you want to delete this panel?`}
            onClose={handleClose}
            onDelete={handleConfirmDelete}
          />
        </DialogContent>
      </Dialog>
    </Box>,
    widgetContainer
  );
}

export function GridStackRender({ componentMap, workstream }) {
  const { panels, instance, events } = useGridStackContext();
  const entries = Object.entries(panels);

  return entries.map(([key, meta]) => {
    const componentData = parseWeightMetaToComponentData(meta);
    const WidgetComponent = componentMap[componentData.name];
    const fixedId = Number.isNaN(Number(key)) ? key : Number(key);
    const widgetContainer = instance.getPanelContainer(fixedId);
    if (!widgetContainer) return null;

    // console.log("component data:", componentData);

    return (
      <PanelPortal
        key={`gridstack-render-portal-${fixedId}-for-${componentData.name}`}
        id={fixedId}
        meta={{ props: componentData.props }}
        WidgetComponent={WidgetComponent}
        widgetContainer={widgetContainer}
        onRemove={events.onDeletePanel}
        componentData={componentData}
        title={meta.title}
        description={meta.description}
        tableId={meta.tableId}
        workstream={workstream}
      />
    );
  });
}
